import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
let mallRouter = require('@/pages/mall/sell/router-config.js')
// let saleCarRouter = require('@/pages/saleCar/router-config.js')
import saleCarRouter from '@/pages/saleCar/router-config.js'
// import Test from './component/Test.vue'

Vue.use(Router)

/**
 * 线上url的拼接方法  https://gateway.shouqiev.com:8443/h5app4/dist/#/ + path
 * 例如 path: '/fillBackInfo'
 * 那么url就是 https://gateway.shouqiev.com:8443/h5app4/dist/#/fillBackInfo
 * 下面做个完整的示例
 * {
        path: '/fillBackInfo',       //路由地址
        meta: {
            title: '填写银行卡信息',    //html页面的title
            content: '',             //不是必填的参数,页面的title和实际内容不太一样的时候,content用于描述页面内的实际内容
        },
        urlParams: [
            {
                name: 'payRefundId', //参数名字
                require: false,      //参数是否是必填项
                tip: '退款id',        //参数的描述
            }
        ]
    }
 */
export default new Router({
    mode: 'hash',
    base: '/dist/',
    routes: [
        {
            path: '/',
            name: 'Error404',
            component: resolve => require(
                ['@/components/Error-404.vue'],
                resolve), //懒加载
        },
        {
            path: '/transfer-give',
            name: 'transfer',
            meta: {
                title: 'GoFun出行'
            },
            component: resolve => require(['@/pages/transfer-give/transfer-index.vue'], resolve) // 懒加载
        },
        {
            path: '/transfer-success',
            name: 'transfer',
            meta: {
                title: 'GoFun出行'
            },
            component: resolve => require(['@/pages/transfer-give/transfer-success.vue'], resolve) // 懒加载
        },
        {
            path: '/fillBackInfo',
            component: resolve => require(
                ['@/pages/fill_bank_info/index.vue'],
                resolve),
            meta: {
                title: '填写银行卡信息',
            },
            urlParams: [
                {
                    name: 'payRefundId',
                    tip: '退款id'
                },
                {
                    name: 'Authorization',
                    tip: '验证token'
                }
            ]
        },
        {
            path: '/rebate',
            component: resolve => require(
                ['@/pages/Agreement/rebate-rule.vue'], //充值协议
                resolve),
            meta: {
                title: '充值协议',
            },
            urlParams: []
        },
        {
            path: '/myService',
            component: resolve => require(
                ['@/pages/myCustomerService/service-index.vue'],
                resolve),
            meta: {
                title: '我的客服',
            },
            urlParams: [
                {
                    name: 'itemUseScenes',
                    tip: '场景来源'
                },
                {
                    name: 'orderId',
                    tip: '订单号'
                },
            ]
        },
        {
            path: '/myService/question',
            component: resolve => require(
                ['@/pages/myCustomerService/service-question.vue'],
                resolve),
            meta: {
                title: '我的客服',
                content: '问题详情'
            },
            urlParams: [
                {
                    name: 'id',
                    require: true,
                    tip: '问题ID'
                }
            ]
        },
        {
            path: '/myService/driveGuide',
            component: resolve => require(
                ['@/pages/myCustomerService/service-driveGuide.vue'],
                resolve),
            meta: {
                title: '驾驶指南',
            },
            urlParams: []
        },
        {
            path: '/myService/driveGuideForMsg',
            component: resolve => require(
                ['@/pages/myCustomerService/service-driveGuide-forMsg.vue'],
                resolve),
            meta: {
                title: '驾驶指南',
            },
            urlParams: []
        },
        {
            path: '/myService/userGuide',
            component: resolve => require(
                ['@/pages/myCustomerService/service-userGuide.vue'],
                resolve),
            meta: {
                title: '新手指南',
            },
            urlParams: []
        },
        {
            path: '/myService/newDriverGuide',
            component: resolve => require(
                ['@/pages/myCustomerService/service-userGuide.vue'],
                resolve),
            meta: {
                title: '新手指南',
            },
            urlParams: []
        },
        {
            path: '/peccancy',
            component: resolve => require(
                ['@/pages/peccancy_processing/indexNew.vue'],
                resolve),
            meta: {
                title: '交通违法',
            },
            urlParams: []
        },
        {
            path: '/peccancy/done',
            component: resolve => require(
                ['@/pages/peccancy_processing/list-done.vue'],
                resolve),
            meta: {
                title: '已处理交通违法',
            },
            urlParams: []
        },
        {
            path: '/peccancy/detail',
            component: resolve => require(
                ['@/pages/peccancy_processing/detail.vue'],
                resolve),
            meta: {
                title: '交通违法',
            },
            urlParams: [
                {
                    name: 'peccancyId',
                    tip: '违法ID'
                },
                {
                    name: 'carId',
                    tip: '车辆ID'
                },
                {
                    name: 'orderId',
                    tip: '订单ID'
                }
            ]
        },
        {
            path: '/peccancy/mySelf',
            component: resolve => require(
                ['@/pages/peccancy_processing/mySelf.vue'],
                resolve),
            meta: {
                title: '自行处理',
            },
            urlParams: []
        },
        {
            path: '/peccancy/pay',
            component: resolve => require(
                ['@/pages/peccancy_processing/pay.vue'],
                resolve),
            meta: {
                title: '平台代缴',
            },
            urlParams: []
        },
        {
            path: '/peccancy/upload',
            component: resolve => require(
                ['@/pages/peccancy_processing/upload.vue'],
                resolve),
            meta: {
                title: '上传处理凭证',
            },
            urlParams: []
        },
        {
            path: '/peccancy/fillBankInfo',
            component: resolve => require(
                ['@/pages/peccancy_processing/fillBankInfo.vue'],
                resolve),
            meta: {
                title: '填写银行卡信息',
            },
            urlParams: [
                {
                    name: 'payRefundId',
                    tip: '退款id'
                },
                {
                    name: 'Authorization',
                    tip: '验证token'
                }
            ]
        },
        { // 阿里新手指南
            path: '/aliUserGuide',
            component: resolve => require(
                ['@/pages/aliUserGuide/aliUserGuide.vue'],
                resolve),
            meta: {
                title: '新手指南',
            },
            urlParams: []
        },
        { // H5用车新手指南
            path: '/userGuideForH5Car',
            component: resolve => require(
                ['@/pages/aliUserGuideForH5Car/aliUserGuide.vue'],
                resolve),
            meta: {
                title: '新手指南',
            },
            urlParams: []
        },
        { // 计价说明
            path: '/chargeDetail',
            component: resolve => require(
                ['@/pages/chargeDetail/chargeDetail.vue'],
                resolve),
            meta: {
                title: '计价说明',
            },
            urlParams: [
                {
                    name: 'carId',
                    require: true,
                    tip: '车辆ID'
                },
            ]
        },
        {
            path: '/payParkingFee',
            component: resolve => require(
                ['@/pages/pay_parking_fee/pay-parking-fee.vue'],
                resolve),
            meta: {
                title: '代缴停车费说明',
            },
            urlParams: [
                {
                    name: 'orderId',
                    tip: '订单ID'
                },
                {
                    name: 'feedbackSource',
                    tip: '场景入口'
                },
                {
                    name: 'createTime',
                    tip: '订单开始时间'
                },
                {
                    name: 'mileage',
                    tip: '公里数'
                },
            ]
        },
        {
            path: '/freeCompensation',
            component: resolve => require(
                ['@/pages/free_compensation/free-compensation.vue'],
                resolve),
            meta: {
                title: '不计免赔服务说明',
            },
            urlParams: [
                {
                    name: 'desc',
                    require: true,
                    tip: '计费规则内容'
                }
            ]
        },
        {
            path: '/newFreeCompensation',
            component: resolve => require(
                ['@/pages/free_compensation/new-free-compensation.vue'],
                resolve),
            meta: {
                title: '基础服务费说明',
            },
        },
        {
            path: '/dailyFreeCompensation',
            component: resolve => require(
                ['@/pages/free_compensation/daily-free-compensation.vue'],
                resolve),
            meta: {
                title: '日租服务费说明',
            },
        },
        {
            path: '/uploadForCar',
            component: resolve => require(
                ['@/pages/uploadForCar/uploadForCar.vue'],
                resolve),
            meta: {
                title: '反馈车况', //验车单拍照
            },
            urlParams: [
                {
                    name: 'parts',
                    require: false,
                    tip: '车损部位'
                }
            ]
        },
        // {
        //     path: '/personalInfo',
        //     component: resolve => require(
        //         ['@/pages/personalInfo/personalInfo.vue'],
        //         resolve),
        //     meta: {
        //         title: '个人信息页面', //文明用车分
        //     },
        //     urlParams: [
        //         {
        //             name: 'cityCode',
        //             require: true,
        //             tip: '城市ID'
        //         }
        //     ]
        // },
        {
            path: '/personalInfo',
            component: resolve => require(
                ['@/pages/civilizeScore/new-personal-info.vue'],
                resolve),
            meta: {
                title: '个人信息页面', //文明用车分
            }
        },
        {
            path: '/activityCenter',
            component: resolve => require(
                ['@/pages/activityCenter/activityCenter.vue'],
                resolve),
            meta: {
                title: '活动中心',
            },
            urlParams: [
                {
                    name: 'cityCode',
                    require: true,
                    tip: '城市ID'
                }
            ]
        },
        {
            // 传递参数：/文明用车分状态/是否为大陆用户/是否开启芝麻信用授权/是否开启免密支付
            path: '/civilizationScore',
            component: resolve => require(
                ['@/pages/personalInfo/civilizationScore.vue'],
                resolve),
            meta: {
                title: '什么是文明用车分',
            },
            urlParams: [
                {
                    name: 'cityCode',
                    require: true,
                    tip: '城市ID'
                }
            ]
        },
        {
            path: '/overPark',
            component: resolve => require(
                ['@/pages/overPark/overPark.vue'],
                resolve),
            meta: {
                title: '调度费',
            },
            urlParams: [
                {
                    name: 'isVirtual',
                    require: true,
                    tip: '是否是虚拟网点'
                }
            ]
        },
        {
            path: '/parkingLotInfoOld', //老版本ui
            component: resolve => require(
                ['@/pages/parkingLotInfo/parkingLotInfoNew.vue'],
                resolve),
            meta: {
                title: '网点详情',
            },
            urlParams: [
                {
                    name: 'parkingId',
                    require: true,
                    tip: '停车场ID'
                }
            ]
        },
        {
            path: '/parkingLotInfo',  // 5.0ui风格
            component: resolve => require(
                ['@/pages/parkingLotInfo/parkingLotInfoV50.vue'],
                resolve),
            meta: {
                title: '网点详情',
            },
            urlParams: [
                {
                    name: 'parkingId',
                    require: true,
                    tip: '停车场ID'
                }
            ]
        },
        {
            path: '/invoiceByTripOrCharge',
            component: resolve => require(
                ['@/pages/invoice/invoiceByTripOrChargeNew.vue'],
                resolve),
            meta: {
                title: '发票与报销',
            },
            urlParams: []
        },
        {
            path: '/invoiceByElectronicOrPaper',
            component: resolve => require(
                ['@/pages/invoice/invoiceByElectronicOrPaperNew.vue'],
                resolve),
            meta: {
                title: '填写开票信息',
            },
            urlParams: []
        },
        {
            path: '/invoiceHistory',
            component: resolve => require(
                ['@/pages/invoice/invoiceHistory.vue'],
                resolve),
            meta: {
                title: '开票历史',
            },
            urlParams: []
        },
        {
            path: '/invoiceDetail', //
            component: resolve => require(
                ['@/pages/invoice/invoiceDetail.vue'],
                resolve),
            meta: {
                title: '发票详情',
            },
            urlParams: [
                {
                    name: 'id',
                    require: true,
                    tip: '发票ID'
                }
            ]
        },
        {
            path: '/chargeRule', //chargeRule?orderId=180818153553010V8SUJY1
            //参数orderId 订单ID
            component: resolve => require(
                ['@/pages/chargeRule/chargeRule.vue'],
                resolve),
            meta: {
                title: '计价规则',
            },
            urlParams: [
                {
                    name: 'orderId',
                    require: true,
                    tip: '订单号'
                },
            ]
        },
        {
            path: '/reportProblem',
            component: resolve => require(
                ['@/pages/reportProblem/reportProblemNew'],
                resolve),
            meta: {
                title: '问题上报',
            },
            urlParams: [
                {
                    name: 'feedbackSource',
                    require: false,
                    tip: '场景来源'
                }
            ]
        },
        {
            path: '/changePhone',
            component: resolve => require(
                ['@/pages/changeTel/checkNowPhone'],
                resolve),
            meta: {
                title: '修改手机号',
                content: '获取当前手机号'
            },
            urlParams: []
        },
        {
            path: '/commitNewPhone',
            component: resolve => require(
                ['@/pages/changeTel/commitNewPhone'],
                resolve),
            meta: {
                title: '修改手机号',
            },
            urlParams: []
        },
        {
            path: '/feedBack',
            component: resolve => require(
                ['@/pages/feedBack/feedBack'],
                resolve),
            meta: {
                title: '意见反馈',
            },
            urlParams: []
        },
        {
            path: '/changePhone',
            component: resolve => require(
                ['@/pages/changeTel/checkNowPhone'],
                resolve),
            meta: {
                title: '修改手机号',
            },
            urlParams: []
        },
        {
            path: '/trafficControl',
            component: resolve => require(
                ['@/pages/trafficControl/trafficControlNew'],
                resolve),
            meta: {
                title: '限行',
            },
            urlParams: [
                {
                    name: 'cityCode',
                    require: true,
                    tip: '城市code'
                },
                {
                    name: 'carId',
                    require: true,
                    tip: '车辆ID'
                },
            ]
        },
        {
            path: '/trafficControlDaily',
            component: resolve => require(
                ['@/pages/trafficControl/trafficControlDaily'],
                resolve),
            meta: {
                title: '限行',
            },
            urlParams: [
                {
                    name: 'carId',
                    require: true,
                    tip: '车辆ID'
                },
                {
                    name: 'startTime',
                    require: true,
                    tip: '开始时间'
                },
                {
                    name: 'endTime',
                    require: true,
                    tip: '结束时间'
                },
            ]
        },
        {
            path: '/inviteFriends',
            component: resolve => require(
                ['@/pages/personalCenter/callFriends/invite'],
                resolve),
            meta: {
                title: '邀请好友',
            },
            urlParams: []
        },
        {
            path: '/callFriendsDetail',
            component: resolve => require(
                ['@/pages/personalCenter/callFriends/detail'],
                resolve),
            meta: {
                title: 'GoFun共享汽车',
            },
            urlParams: []
        },
        {
            path: '/demo',
            component: resolve => require(
                ['@/pages/demo/demo'],
                resolve),
            meta: {
                title: 'GoFun共享汽车',
            },
            urlParams: []
        },
        {
            path: '/demo1',
            component: resolve => require(
                ['@/pages/demo/demo1'],
                resolve),
            meta: {
                title: '红包雨demo',
            },
        },
        {
            path: '/memberAgreement',
            component: resolve => require(
                ['@/pages/memberAgreement/memberAgreementNew'],
                resolve),
            meta: {
                title: '法律条款与平台规则',
            },
            urlParams: []
        },
        // {
        //     path: '/memberAgreement',
        //     component: resolve => require(
        //         ['@/pages/memberAgreement/memberAgreement'],
        //         resolve),
        //     meta: {
        //         title: '会员协议',
        //     },
        //     urlParams: []
        // },
        {
            path: '/cleanReport',
            component: resolve => require(
                ['@/pages/reportProblem/cleanReport'],
                resolve),
            meta: {
                title: '车辆清洁问题上报',
            },
            urlParams: []
        },
        {
            path: '/damageReport',
            component: resolve => require(
                ['@/pages/reportProblem/damageReport'],
                resolve),
            meta: {
                title: '车辆损伤问题上报',
            },
            urlParams: []
        },
        {
            path: '/otherReport',
            component: resolve => require(
                ['@/pages/reportProblem/otherReport'],
                resolve),
            meta: {
                title: '车辆其他问题上报',
            },
            urlParams: [
                {
                    name: 'templateId',
                    require: true,
                    tip: '问题上报模板 templateId',
                },
                {
                    name: 'typeId',
                    require: true,
                    tip: '问题上报模板 typeId',
                },
            ]
        },
        { // 多收停车费
            path: '/otherReportOverPay',
            component: resolve => require(
                ['@/pages/reportProblem/otherReportOverPay'],
                resolve),
            meta: {
                title: '多收停车费',
            },
            urlParams: [
                {
                    name: 'templateId',
                    require: true,
                    tip: '问题上报模板 templateId',
                },
                {
                    name: 'typeId',
                    require: true,
                    tip: '问题上报模板 typeId',
                },
            ]
        },
        { // 加油费用返还
            path: '/otherReportOilFee',
            component: resolve => require(
                ['@/pages/reportProblem/otherReportOilFee'],
                resolve),
            meta: {
                title: '加油费用返还',
            },
            urlParams: [
                {
                    name: 'templateId',
                    require: true,
                    tip: '问题上报模板 templateId',
                },
                {
                    name: 'typeId',
                    require: true,
                    tip: '问题上报模板 typeId',
                },
            ]
        },
        {
            path: '/reportHistory',
            component: resolve => require(
                ['@/pages/reportProblem/reportHistory'],
                resolve),
            meta: {
                title: '上报历史',
            },
            urlParams: []
        },
        {
            path: '/orderHistory',
            component: resolve => require(
                ['@/pages/reportProblem/orderHistory'],
                resolve),
            meta: {
                title: '问题上报',
                content: '订单历史'
            },
            urlParams: []
        },
        {
            path: '/changeCar',
            component: resolve => require(
                ['@/pages/changeCar/changeCar'],
                resolve),
            meta: {
                title: '换车指南',
            },
            urlParams: []
        },
        {
            path: '/privacy',
            component: resolve => require(
                ['@/pages/Agreement/privacy'],
                resolve),
            meta: {
                title: 'GoFun出行隐私保护说明',
            },
            urlParams: []
        },
        {
            path: '/parkingFeeCompensate',
            component: resolve => require(
                ['@/pages/Agreement/parkingFeeCompensate'],
                resolve),
            meta: {
                title: '停车费补偿规则说明',
            },
            urlParams: []
        },
        {
            //与原来不计免赔对应的新版本 出行保障
            path: '/insureRule',
            component: resolve => require(
                ['@/pages/Agreement/insureRule'],
                resolve),
            meta: {
                title: '出行保障',
            },
            urlParams: [
                {
                    name: 'orderId',
                    require: true,
                    tip: '订单号'
                },
            ]
        },
        {
            path: '/privacyProtocol',
            component: resolve => require(
                ['@/pages/Agreement/privacyProtocol'],
                resolve),
            meta: {
                title: 'GoFun车服隐私政策',
            }
        },
        {
            path: '/insureAgreement',
            component: resolve => require(
                ['@/pages/Agreement/insureAgreement-new'],
                resolve),
            meta: {
                title: '出行保障协议',
            },
            urlParams: [
                {
                    name: 'width',
                    require: true,
                    tip: '页面宽度',
                },
            ]
        },
        {
            path: '/chargeRuleWithInsure', //chargeRuleWithInsure?orderId=180818153553010V8SUJY1
            component: resolve => require(
                ['@/pages/chargeRule/chargeRuleWithInsure'],
                resolve),
            meta: {
                title: '计价规则',
            },
        },
        {
            path: '/chargeRuleWithNewInsure', //chargeRuleWithInsure?orderId=180818153553010V8SUJY1
            component: resolve => require(
                ['@/pages/chargeRule/chargeRuleWithNewInsure'],
                resolve),
            meta: {
                title: '计价规则',
            },
        },
        {
            path: '/chargeRuleWithFinalInsure', //chargeRuleWithInsure?orderId=180818153553010V8SUJY1
            component: resolve => require(
                ['@/pages/chargeRule/chargeRuleWithFinalInsure'],
                resolve),
            meta: {
                title: '计价规则',
            },
        },
        // {
        //     path: '/dailyRentRule', //chargeRuleWithInsure?orderId=180818153553010V8SUJY1
        //     component: resolve => require(
        //         ['@/pages/chargeRule/dailyRentRule'],
        //         resolve),
        //     meta: {
        //         title: '计价规则',
        //     },
        // },
        {
            path: '/dailyRentRule', //日租计价规则
            component: resolve => require(
                ['@/pages/chargeRule/dailyRentRuleNew'],
                resolve),
            meta: {
                title: '日租规则',
            },
        },
        {
            path: '/shareOld',
            component: resolve => require(
                ['@/pages/share/shareOld'],
                resolve),
            meta: {
                title: '行程完成',
            },
        },
        {
            path: '/share',
            component: resolve => require(
                ['@/pages/share/share'],
                resolve),
            meta: {
                title: '行程完成',
            },
        },
        { // app5订单完成页
            path: '/newShare',
            component: resolve => require(
                ['@/pages/share/shareNew2'],
                resolve),
            meta: {
                title: '行程完成',
            },
        },
        {
            path: '/getBlock',
            component: resolve => require(
                ['@/pages/share/index'],
                resolve),
            meta: {
                title: '领GoFun能量方块',
            },
            urlParams: [
                {
                    name: 'orderId',
                    require: true,
                    tip: '订单号'
                },
            ]
        },
        {
            path: '/getBlockmiddleware',
            component: resolve => require(
                ['@/pages/share/middleware'],
                resolve),
            meta: {
                title: '',
            },
        },
        {
            path: '/car_damage_home',
            component: resolve => require(
                ['@/pages/carRepair/car_damage_home'],
                resolve),
            meta: {
                title: '车损',
            },
            urlParams: [
                {
                    name: 'carId',
                    require: true,
                    tip: '车辆ID'
                }, {
                    name: 'cheWuToken',
                    require: false,
                    tip: '车务Token'
                }, {
                    name: 'repairToken',
                    require: false,
                    tip: '维修系统token'
                }
            ]
        },
        {
            path: '/reportedDamage',
            component: resolve => require(
                ['@/pages/carRepair/reported-damage'],
                resolve),
            meta: {
                title: '已上报问题',
            }
        },
        {
            path: '/reviewProblem',
            component: resolve => require(
                ['@/pages/reportProblem/reviewProblem'],
                resolve),
            meta: {
                title: '问题上报',
            },
            urlParams: []
        },
        {
            path: '/testReport',  //文明用车调研
            meta: {
                title: '文明用车调研',
            },
            component: resolve => require(
                ['@/pages/reportProblem/testReport'],
                resolve),
        },
        {
            //go票大厅
            path: '/goTicket/Index',  //首页
            meta: {
                title: 'Go券商城',
            },
            component: resolve => require(
                ['@/pages/goTicket/Index'],
                resolve),
        },
        {
            path: '/goTicket/pay',  //支付
            meta: {
                title: '支付',
            },
            component: resolve => require(
                ['@/pages/goTicket/Pay'],
                resolve),
        },
        {
            path: '/goTicket/SpikeDetails',  //秒杀详情
            meta: {
                title: '秒杀详情',
            },
            component: resolve => require(
                ['@/pages/goTicket/SpikeDetails'],
                resolve),
        },
        {
            path: '/goTicket/Details',  //普通详情
            meta: {
                title: '优惠详情',
            },
            component: resolve => require(
                ['@/pages/goTicket/Details'],
                resolve),
        },
        {
            path: '/goTicket/Record',  //支付列表
            meta: {
                title: '购买记录',
            },
            component: resolve => require(
                ['@/pages/goTicket/Record'],
                resolve),
        },
        {
            //改版go票大厅
            path: '/goTicket_new/Index',  //首页
            meta: {
                title: 'Go券商城',
            },
            component: resolve => require(
                ['@/pages/goTicket_new/Index'],
                resolve),
        },
        {
            path: '/goTicket_new/pay',  //支付
            meta: {
                title: '支付',
            },
            component: resolve => require(
                ['@/pages/goTicket_new/Pay'],
                resolve),
        },
        {
            path: '/goTicket_new/SpikeDetails',  //秒杀详情
            meta: {
                title: '秒杀详情',
                ticketRequiresAuth: true
            },
            component: resolve => require(
                ['@/pages/goTicket_new/SpikeDetails'],
                resolve),
        },
        {
            path: '/goTicket_new/Details',  //普通详情
            meta: {
                title: '优惠详情',
                ticketRequiresAuth: true
            },
            component: resolve => require(
                ['@/pages/goTicket_new/Details'],
                resolve),
        },
        {
            path: '/goTicket_new/Record',  //支付列表
            meta: {
                title: '购买记录',
                ticketRequiresAuth: true
            },
            component: resolve => require(
                ['@/pages/goTicket_new/Record'],
                resolve),
        },
        {
            path: '/goTicket_new/Location',  //定位
            meta: {
                title: '设置城市',
            },
            component: resolve => require(
                ['@/pages/goTicket_new/Location'],
                resolve)
        },
        {
            path: '/recharge',  //充值列表页面
            meta: {
                title: '充值',
            },
            component: resolve => require(
                ['@/pages/recharge/rechargeNew'],
                resolve),
        },
        {
            path: '/recharge/cityChange',  //切换城市
            meta: {
                title: '切换城市',
            },
            component: resolve => require(
                ['@/pages/recharge/cityChange.vue'],
                resolve),
        },
        {
            path: '/encourageRule',  //鼓励金规则
            meta: {
                title: '什么是鼓励金',
            },
            component: resolve => require(
                ['@/pages/encourage/encourageRule'],
                resolve),
        },
        {
            path: '/encourageActivity',  //鼓励金开启宝箱活动
            meta: {
                title: '开GoFun赚鼓励金',
            },
            component: resolve => require(
                ['@/pages/encourage/encourageActivity'],
                resolve),
        },
        {
            path: '/goTicket_new/CouponList',  //优惠券列表
            meta: {
                title: '秒杀列表',
            },
            component: resolve => require(
                ['@/pages/goTicket_new/CouponList'],
                resolve),
        },
        {
            path: '/goTicket_new/RecommendCoupon',  //优惠券列表
            meta: {
                title: '精选推荐',
            },
            component: resolve => require(
                ['@/pages/goTicket_new/RecommendCoupon'],
                resolve),
        },
        {
            path: '/goTicket_new/mapMarker',  //位置地图组件
            meta: {
                title: '',
            },
            component: resolve => require(
                ['@/pages/goTicket_new/components/mapMarker'],
                resolve),
        },
        {
            path: '/longRent',  //整租首页
            meta: {
                title: '整租套餐',
            },
            component: resolve => require(
                ['@/pages/longRent/longRent-index'],
                resolve),
        },
        {
            path: '/longRent/state',  //整租状态页
            meta: {
                title: '整租',
            },
            component: resolve => require(
                ['@/pages/longRent/longRent-state'],
                resolve),
        },
        {
            path: '/longRent/parkingList',  //整租网点页面
            meta: {
                title: '全部网点',
            },
            component: resolve => require(
                ['@/pages/longRent/longRent-parkingList'],
                resolve),
        },
        {
            path: '/longRent/agreement',  //整租网点页面
            meta: {
                title: '整租车辆租赁服务协议',
            },
            component: resolve => require(
                ['@/pages/longRent/longRent-agreement'],
                resolve),
        },
        {
            path: '/userManual/daily-user-manual',  //日租使用手册
            meta: {
                title: '日租使用手册',
            },
            component: resolve => require(
                ['@/pages/userManual/daily-user-manual'],
                resolve),
        },
        {
            path: '/userManual/daily-rent-rules-agreement',  //预约用车规则说明
            meta: {
                title: '预约用车规则说明',
            },
            component: resolve => require(
                ['@/pages/userManual/daily-rent-rules-agreement.vue'],
                resolve),
        },
        {
            path: '/lightenCity/home',  //点亮城市
            meta: {
                title: '点亮城市',
            },
            component: resolve => require(
                ['@/pages/lightenCity/home'],
                resolve),
            urlParams: [
                {
                    name: 'cityCode',
                    require: true,
                    tip: '城市code',
                }
            ]
        },
        {
            path: '/lightenCity/allRanking',  //点亮城市
            meta: {
                title: '点亮城市',
            },
            component: resolve => require(
                ['@/pages/lightenCity/all-ranking'],
                resolve),
            urlParams: [
                {
                    name: 'cityCode',
                    require: true,
                    tip: '城市code',
                }
            ]
        },
        {
            path: '/lightenCity/activityRule',  //点亮城市活动规则
            meta: {
                title: '点亮城市',
            },
            component: resolve => require(
                ['@/pages/lightenCity/activityRule'],
                resolve)
        },
        {
            path: '/aboutPerformanceBond',  //关于履约保证金
            meta: {
                title: '关于履约保证金',
            },
            component: resolve => require(
                ['@/pages/Agreement/aboutPerformanceBond'],
                resolve)
        },
        {
            path: '/civilizeScore/scoreList',  //文明行为分数对照表
            meta: {
                title: ' ',
            },
            component: resolve => require(
                ['@/pages/civilizeScore/civilizeScore-scoreList'],
                resolve)
        },
        {
            path: '/civilizeScore/record',  //文明行为分数变更记录
            meta: {
                title: '    ',
            },
            component: resolve => require(
                ['@/pages/civilizeScore/civilizeScore-record'],
                resolve)
        },
        {
            path: '/civilizeScore/equity',  //文明用车分权益详情页
            meta: {
                title: '权益详情',
            },
            component: resolve => require(
                ['@/pages/civilizeScore/civilizeScore-equity'],
                resolve),
            urlParams: [
                {
                    name: 'equityId',
                    require: true,
                    tip: '文明权益index',
                }
            ]
        },
        {
            path: '/GoFunCome',  //GoFun来袭 登录页
            meta: {
                title: 'GoFun来袭',
            },
            component: resolve => require(
                ['@/pages/GoFunCome/GoFunCome'],
                resolve)
        },
        {
            path: '/GoFunComeNew',  //GoFun来袭 登录页 冲200返200
            meta: {
                title: 'GoFun来袭',
            },
            component: resolve => require(
                ['@/pages/GoFunCome/GoFunComeNew'],
                resolve)
        },
        {
            path: '/thanksg',  //GoFun来袭 登录页 感恩节回馈礼活动
            meta: {
                title: 'GoFun感恩有礼',
            },
            component: resolve => require(
                ['@/pages/GoFunCome/GoFunComeThanksgiving'],
                resolve)
        },
        {
            path: '/reward',  //车源平台 车主奖励
            meta: {
                title: '奖励详情',
            },
            component: resolve => require(
                ['@/pages/recommendation/reward'],
                resolve)
        },
        {
            path: '/recommendation',  //车源平台 车主奖励
            meta: {
                title: '推荐车辆有奖',
            },
            component: resolve => require(
                ['@/pages/recommendation/index'],
                resolve)
        },
        {
            path: '/cash',  //车源平台 车主奖励
            meta: {
                title: '奖励详情',
            },
            component: resolve => require(
                ['@/pages/recommendation/cash'],
                resolve)
        },
        {
            path: '/chargeDetail/default',  //计价详情-分时
            meta: {
                title: '分时计价',
            },
            component: resolve => require(
                ['@/pages/chargeDetail/chargeDetail-default'],
                resolve),
            urlParams: [
                {
                    name: 'carId',
                    require: true,
                    tip: '车辆ID',
                }
            ]
        },
        {
            path: '/chargeDetail/activities',  //计价详情-套餐
            meta: {
                title: '套餐计价',
            },
            component: resolve => require(
                ['@/pages/chargeDetail/chargeDetail-activities'],
                resolve),
            urlParams: [
                {
                    name: 'carId',
                    require: true,
                    tip: '车辆ID',
                },
                {
                    name: 'activityId',
                    require: true,
                    tip: '套餐ID',
                }
            ]
        },
        {
            path: '/recommendBuildPoint',  // 推荐建点分享页
            meta: {
                title: 'GoFun共享汽车',
            },
            component: resolve => require(
                ['@/pages/recommendBuildPoint/recommendBuildPoint'],
                resolve)
        },
        {
            path: '/recommendBuildPointRule',  // 推荐建点推荐规则
            meta: {
                title: '推荐规则',
            },
            component: resolve => require(
                ['@/pages/Agreement/recommendBuildPointRule'],
                resolve)
        },
        {
            path: '/eslimateCost',  // 费用预估
            meta: {
                title: '费用预估',
            },
            component: resolve => require(
                ['@/pages/eslimate/eslimateCost'],
                resolve)
        },
        {
            path: '/accident/index',  // 出险救援-首页
            meta: {
                title: '出险救援',
            },
            component: resolve => require(
                ['@/pages/accident/index'],
                resolve)
        },
        {
            path: '/accident/select-type',  // 出险救援-选择出险类型
            meta: {
                title: '出险救援',
            },
            component: resolve => require(
                ['@/pages/accident/select-type'],
                resolve)
        },
        {
            path: '/accident/select-type-new',  // 出险救援-选择出险类型新
            meta: {
                title: '出险救援',
            },
            component: resolve => require(
                ['@/pages/accident/select-type-new'],
                resolve)
        },
        {
            path: '/accident/rescue',  // 出险救援-救援页面(小程序使用)
            meta: {
                title: '救援',
            },
            component: resolve => require(
                ['@/pages/accident/rescue'],
                resolve)
        },
        {
            path: '/accident/rescue-new',  // 出险救援-救援页面（app使用）
            meta: {
                title: '救援',
            },
            component: resolve => require(
                ['@/pages/accident/rescue-new'],
                resolve)
        },
        {
            path: '/accident/record',  // 事故出险记录
            meta: {
                title: '出险记录',
            },
            component: resolve => require(
                ['@/pages/accident/record'],
                resolve)
        },
        {
            path: '/accident/detail',  // 事故出险记录详情页面
            meta: {
                title: '出险详情',
            },
            component: resolve => require(
                ['@/pages/accident/record-detail'],
                resolve)
        },
        {
            path: '/accident/describe',  // 事故描述(第一步)
            meta: {
                title: '事故描述',
            },
            component: resolve => require(
                ['@/pages/accident/describe'],
                resolve)
        },
        {
            path: '/accident/reportPolice',  // 报警报案(第二步)
            meta: {
                title: '报警报案',
            },
            component: resolve => require(
                ['@/pages/accident/reportPolice'],
                resolve)
        },
        {
            path: '/accident/supplyInformation',  // 补充信息(第三步)
            meta: {
                title: '补充信息',
            },
            component: resolve => require(
                ['@/pages/accident/supplyInformation'],
                resolve)
        },
        {
            path: '/accident/info',  // 事故出险案件查询页面
            meta: {
                title: '案件查询',
            },
            component: resolve => require(
                ['@/pages/accident/info'],
                resolve)
        },
        {
            path: '/accident/beforehand_info',  // 垫付信息
            meta: {
                title: '填写垫付信息',
            },
            component: resolve => require(
                ['@/pages/accident/beforehand_info'],
                resolve)
        },
        {
            path: '/accident/done',  // 救援已完成
            meta: {
                title: '救援已完成',
            },
            component: resolve => require(
                ['@/pages/accident/done'],
                resolve)
        },
        {
            path: '/longRent-guide',  // 整租流程
            meta: {
                title: '整租',
            },
            component: resolve => require(
                ['@/pages/longRent/longRent-guide'],
                resolve)
        },
        {
            path: '/crossReturnMoney',  // 跨区还车服务费
            meta: {
                title: '跨区还车服务费规则',
            },
            component: resolve => require(
                ['@/pages/Agreement/crossReturnMoney'],
                resolve)
        },
        {
            path: '/agreement/traffic-violation-rule',  // 交通违法处理规则
            meta: {
                title: '交通违法处理规则',
            },
            component: resolve => require(
                ['@/pages/Agreement/traffic-violation-rule'],
                resolve)
        },
        {
            path: '/agreement/longRent-rule',  // 整租规则和说明
            meta: {
                title: '整租规则',
            },
            component: resolve => require(
                ['@/pages/Agreement/longRent-rule'],
                resolve)
        },
        {
            path: '/feeInformation/refund-or-payment',  //日租补交费用 和 退款明细
            meta: {
                title: '',
            },
            component: resolve => require(
                ['@/pages/feeInformation/refund-or-payment'],
                resolve),
            urlParams: [
                {
                    name: 'orderId',
                    require: true,
                    tip: '订单Id'
                },
            ]
        },
        {
            path: '/feeInformation/fuel-fee',  // 日租燃油费-补交或返还
            meta: {
                title: '燃油费',
            },
            component: resolve => require(
                ['@/pages/feeInformation/fuel-fee'],
                resolve),
        },
        {
            path: '/feeInformation/oil-fee',
            meta: {
                title: '加油服务费',
            },
            component: resolve => require(
                ['@/pages/feeInformation/oil-fee'],
                resolve),
        },
        {
            path: '/feeInformation/wholeRent',
            meta: {
                title: '费用说明',
            },
            component: resolve => require(
                ['@/pages/feeInformation/wholeRent'],
                resolve),
        },
        {
            path: '/feeInformation/parking-fee',
            meta: {
                title: '停车费用说明',
            },
            component: resolve => require(
                ['@/pages/feeInformation/parking-fee'],
                resolve),
        },
        {
            path: '/earnestMoney',
            meta: {
                title: '保证金说明',
            },
            component: resolve => require(['@/pages/earnestMoney/index'],resolve),
        },
        {
            path: '/feeInformation/charge-fee',  // 充电费用
            meta: {
                title: '充电费用',
            },
            component: resolve => require(
                ['@/pages/feeInformation/charge-fee'],
                resolve)
        },
        {
            path: '/charge/charge-guide',  // 充电指南
            meta: {
                title: '充电指南',
            },
            component: resolve => require(
                ['@/pages/charge/charge-guide'],
                resolve)
        },
        {
            path: '/charge/battery',  // 电池小知识
            meta: {
                title: '电池小知识',
            },
            component: resolve => require(
                ['@/pages/charge/battery-tips'],
                resolve)
        },
        {
            path: '/charge/charge-assistant',  // 充电助手
            meta: {
                title: '充电助手',
            },
            component: resolve => require(
                ['@/pages/charge/charge-assistant'],
                resolve)
        },
        {
            path: '/charge/charge-city',  // 支持充电的城市
            meta: {
                title: '支持充电的城市',
            },
            component: resolve => require(
                ['@/pages/charge/charge-city'],
                resolve)
        },
        {
            path: '/civilizeScore/civilized-behavior',  //文明用车分-文明行为规则
            meta: {
                title: '分数计算规则',
            },
            component: resolve => require(
                ['@/pages/civilizeScore/civilized-behavior'],
                resolve)
        },
        {
            path: '/civilizeScore/uncivilized-behavior',  //文明用车分-不文明行为约束
            meta: {
                title: '不文明行为约束',
            },
            component: resolve => require(
                ['@/pages/civilizeScore/uncivilized-behavior'],
                resolve)
        },
        {
            path: '/civilizeScore/low-penalty',  //文明用车分-低分管理费
            meta: {
                title: '低分管理费',
            },
            component: resolve => require(
                ['@/pages/civilizeScore/low-penalty'],
                resolve)
        },
        {
            path: '/fuelcost',  // 车辆燃油附加费
            meta: {
                title: '燃油附加费说明',
            },
            component: resolve => require(
                ['@/pages/eslimate/fuelcost'],
                resolve)
        },
        {
            path: '/myFormer',  //我的前任-欢迎动画页
            meta: {
                title: '我的前任',
            },
            component: resolve => require(
                ['@/pages/myFormer/welcome'],
                resolve)
        },
        {
            path: '/myFormer/index',  //我的前任-首页
            meta: {
                title: '我的前任',
            },
            component: resolve => require(
                ['@/pages/myFormer/index'],
                resolve)
        },
        {
            path: '/myFormer/cityChange',  //我的前任-选择城市
            meta: {
                title: '切换城市',
            },
            component: resolve => require(
                ['@/pages/myFormer/cityChange'],
                resolve)
        },
        {
            path: '/myFormer/rights',  //我的前任-权益说明
            meta: {
                title: '文明分权益',
            },
            component: resolve => require(
                ['@/pages/myFormer/rights'],
                resolve)
        },
        {
            path: '/vehicleGuide',  //车型指南
            meta: {
                title: '车型指南',
            },
            component: resolve => require(
                ['@/pages/vehicleGuide/vehicleGuide'],
                resolve)
        },
        {
            path: '/myFormer/rankingList',  //我的前任-排行榜
            meta: {
                title: '念念不忘排行榜',
            },
            component: resolve => require(
                ['@/pages/myFormer/rankingList'],
                resolve)
        },
        {
            path: '/myService/restart',  //艾瑞泽启动指南
            meta: {
                title: '艾瑞泽启动指南',
            },
            component: resolve => require(
                ['@/pages/myCustomerService/service-restart'],
                resolve)
        },
        {
            path: '/td/survey',
            name: '',
            meta: {
                title: '问卷调查'
            },
            component: resolve => require(['@/pages/tasteDrive/survey.vue'], resolve)
        },
        {
            path: '/td/activityShare',
            name: '',
            meta: {
                title: '活动分享'
            },
            component: resolve => require(['@/pages/tasteDrive/activityShare.vue'], resolve)
        },
        {
            path: '/jobList',  //我的客服--客服工单列表
            meta: {
                title: '处理进度',
            },
            component: resolve => require(
                ['@/pages/myCustomerService/job-list'],
                resolve)
        },
        {
            path: '/jobDetail',  //我的客服--客服工单咨询详情
            meta: {
                title: '咨询详情',
            },
            component: resolve => require(
                ['@/pages/myCustomerService/job-detail'],
                resolve)
        },
        {
            path: '/payment',  //我的客服--平台缴费
            meta: {
                title: '平台缴费',
            },
            component: resolve => require(
                ['@/pages/myCustomerService/payment'],
                resolve)
        },
        {
            path: '/payment-detail',  //我的客服--平台缴费--平台缴费明细
            meta: {
                title: '平台缴费明细',
            },
            component: resolve => require(
                ['@/pages/myCustomerService/payment-detail'],
                resolve)
        },
        {
            path: '/payment/done',  //我的客服--已处理平台缴费
            meta: {
                title: '已处理平台缴费',
            },
            component: resolve => require(
                ['@/pages/myCustomerService/paymentDone'],
                resolve)
        },
        {
            path: '/urged',  //我的客服--已处理平台缴费
            meta: {
                title: '催促处理',
            },
            component: resolve => require(
                ['@/pages/myCustomerService/urged'],
                resolve)
        },
        {
            path: '/orders',  //我的客服--全部行程
            meta: {
                title: '全部行程',
            },
            component: resolve => require(
                ['@/pages/myCustomerService/orders'],
                resolve)
        },
        {
            path: '/platform-payment-detail',  // 平台缴费详情
            meta: {
                title: '平台缴费详情',
            },
            component: resolve => require(
                ['@/pages/myCustomerService/platform-payment-detail'],
                resolve)
        },
        {
            path: '/pay',  // 支付页面
            meta: {
                title: '支付',
            },
            component: resolve => require(
                ['@/pages/myCustomerService/pay'],
                resolve)
        },
        {
            path: '/disapproval-cost',  // 对费用不认可-费用争议
            meta: {
                title: '对费用不认可',
            },
            component: resolve => require(
                ['@/pages/reportProblem/disapproval-cost'],
                resolve)
        },
        {
            path: '/disapproval-fine',  // 对罚款不认可-交通违法争议
            meta: {
                title: '对罚款不认可',
            },
            component: resolve => require(
                ['@/pages/reportProblem/disapproval-fine'],
                resolve)
        },
        {
            path: '/disapproval-pay',  // 对缴费不认可-推费争议
            meta: {
                title: '对缴费不认可',
            },
            component: resolve => require(
                ['@/pages/reportProblem/disapproval-pay'],
                resolve)
        },
        {
            path: '/by-train-commentary',  // 顺路车小解说
            meta: {
                title: '顺路车小解说',
            },
            component: resolve => require(
                ['@/pages/Agreement/by-train-commentary'],
                resolve)
        },
        {
            path: '/travel-card-rules',  // 出行卡购买及使用规则
            meta: {
                title: '出行卡购买及使用规则',
            },
            component: resolve => require(
                ['@/pages/Agreement/travel-card-rules'],
                resolve)
        },
        {
            path: '/myService/phoneList',  // 我的客服电话列表
            meta: {
                title: '选择电话',
            },
            component: resolve => require(
                ['@/pages/myCustomerService/service-phonelist'],
                resolve)
        },
        {
            path: '/invite-new-user/invite',  // 老拉新-邀请有礼
            meta: {
                title: '邀请有礼',
            },
            component: resolve => require(
                ['@/pages/invite-new-user/invite'],
                resolve)
        },
        {
            path: '/invite-new-user/coupon',  // 老拉新-累计奖励
            meta: {
                title: '累计奖励',
            },
            component: resolve => require(
                ['@/pages/invite-new-user/coupon'],
                resolve)
        },
        {
            path: '/new-retail',  // 12.12新零售
            meta: {
                title: '12.12会员 狂欢盛典',
            },
            component: resolve => require(
                ['@/pages/newRetail/index'],
                resolve)
        },
        {
            path: '/new-retail-car-info',  // 12.12新零售详情页
            meta: {
                title: '12.12会员 狂欢盛典',
            },
            component: resolve => require(
                ['@/pages/newRetail/carInfo'],
                resolve)
        },
        {
            path: '/new-retail-car-rules',  // 12.12新零售活动细则
            meta: {
                title: '活动细则',
            },
            component: resolve => require(
                ['@/pages/newRetail/activityrules'],
                resolve)
        },
        {
            path: '/c2c-hosting',  // 出行卡购买及使用规则
            meta: {
                title: '托管信息',
            },
            component: resolve => require(
                ['@/pages/c2cHosting/hosting'],
                resolve)
        },
        {
            path: '/overTimeAmount',  // 逾期费说明
            meta: {
                title: '逾期费用说明',
            },
            component: resolve => require(
                ['@/pages/Agreement/overTimeAmount'],
                resolve)
        },
        {
            path: '/bookingFee',  // 预约服务费
            meta: {
                title: '预约服务费',
            },
            urlParams: [
                {
                    name: 'type', // 参数名字
                    require: false, // 参数是否是必填项
                    tip: 'type的类型，type===daily时显示日租预约服务费', // 参数的描述
                }
            ],
            component: resolve => require(
                ['@/pages/Agreement/bookingFee'],
                resolve)
        },
        {
            path: '/dailyDeposit',  // 日租保证金
            meta: {
                title: '日租保证金',
            },
            component: resolve => require(
                ['@/pages/Agreement/dailyDeposit'],
                resolve)
        },
        {
            path: '/long-rent/submit-intention-car',  // 整租留资-填写意向车型
            meta: {
                title: '企业用车',
            },
            component: resolve => require(
                ['@/pages/longRent/submit-intention-car'],
                resolve)
        },
        {
            path: '/long-rent/submit-success',  // 整租留资-提交成功
            meta: {
                title: '企业用车',
            },
            component: resolve => require(
                ['@/pages/longRent/submit-success'],
                resolve)
        },
        {
            path: '/adMonitoring',  // 广告监控
            meta: {
                title: '广告监控',
            },
            component: resolve => require(
                ['@/pages/monitoring/adMonitoring'],
                resolve)
        },
        {
            path: '/channel-invite/login',  // 渠道拉新监控-登录
            meta: {
                title: '登录',
            },
            component: resolve => require(
                ['@/pages/channel-invite/login'],
                resolve)
        },
        {
            path: '/channel-invite/channel-invite-data',  // 渠道拉新监控-渠道拉新数据
            meta: {
                title: '渠道拉新数据',
            },
            component: resolve => require(
                ['@/pages/channel-invite/channel-invite-data'],
                resolve)
        },
        {
            path: '/oil-rule',  // 加油规则说明
            meta: {
                title: '加油规则说明',
            },
            component: resolve => require(
                ['@/pages/reportProblem/oilRule'],
                resolve)
        },
        {
            path: '/long-rent/submit-intention-car',  // 整租留资-填写意向车型
            meta: {
                title: '', // title由url上动态获取
            },
            component: resolve => require(
                ['@/pages/longRent/submit-intention-car'],
                resolve)
        },
        {
            path: '/long-rent/submit-success',  // 整租留资-提交成功
            meta: {
                title: '提交成功',
            },
            component: resolve => require(
                ['@/pages/longRent/submit-success'],
                resolve)
        },
        {
            path: '/2019yearEndInventory',  // 年终盘点
            meta: {
                title: '年终盘点',
            },
            component: resolve => require(
                ['@/pages/2019yearEndInventory/2019yearEndInventory'],
                resolve)
        },
        {
            path: '/2019yearEndInventory/init',  // 年终盘点
            meta: {
                title: '年终盘点',
            },
            component: resolve => require(
                ['@/pages/2019yearEndInventory/init'],
                resolve)
        },
        {
            path: '/shareScreenshotDemo',  // 分享截图demo
            meta: {
                title: '分享截图demo',
            },
            component: resolve => require(
                ['@/pages/demo/shareScreenshotDemo'],
                resolve)
        },
        {
            path: '/BlockChainData',
            meta: {
                title: '上链数据',
                keepAlive: true,
            },
            component: resolve => require(
                ['@/pages/creditBlockChain/BlockChainData'],
                resolve
            )
        },
        {
            path: '/SaveCertificate',
            meta: {
                title: '存证证书',
            },
            component: resolve => require(
                ['@/pages/creditBlockChain/SaveCertificate'],
                resolve
            )
        },
        {
            path: '/bond-to-balance',
            meta: {
                title: '保证金转余额',
            },
            component: resolve => require(
                ['@/pages/bond/bond-to-balance'],
                resolve
            )
        },
        {
            path: '/rentalCarVerifyForm',
            meta: {
                title: '确认车辆交接单',
            },
            component: resolve => require(
                ['@/pages/rentalCarVerifyForm/index'],
                resolve
            )
        },
        {
            path: '/IntentionSurvey',
            meta: {
                title: '购车意向调查',
            },
            component: resolve => require(
                ['@/pages/dazhong/IntentionSurvey'],
                resolve
            )
        },
        {
            path: '/ReserveDrive',
            meta: {
                title: '预约试驾',
            },
            component: resolve => require(
                ['@/pages/dazhong/ReserveDrive'],
                resolve
            )
        },
        {
            path: '/SelectAgent',
            meta: {
                title: '选择经销商',
            },
            component: resolve => require(
                ['@/pages/dazhong/SelectAgent'],
                resolve
            )
        },
        {
            path: '/ReserveSuccess',
            meta: {
                title: '预约成功',
            },
            component: resolve => require(
                ['@/pages/dazhong/ReserveSuccess'],
                resolve
            )
        },
        {
            path: '/DazhongShare',
            meta: {
                title: '分享得优惠券',
            },
            component: resolve => require(
                ['@/pages/dazhong/DazhongShare'],
                resolve
            )
        },
        {
            path: '/Disworkorder',
            meta: {
                title: '',
            },
            component: resolve => require(
                ['@/pages/disworkorder/disworkorder'],
                resolve
            )
        },
        {
            path: '/reportProblemReturnCar', // 0公里自动还车的问题上报，和原功能冲突较多，所以复制一份
            component: resolve => require(
                ['@/pages/reportProblemReturnCar/reportProblemNew'],
                resolve),
            meta: {
                title: '问题上报',
            },
            urlParams: [
                {}
            ]
        },
        {
            path: '/cleanReportReturnCar',
            component: resolve => require(
                ['@/pages/reportProblemReturnCar/cleanReport'],
                resolve),
            meta: {
                title: '车辆清洁问题上报',
            },
            urlParams: []
        },
        {
            path: '/damageReportReturnCar',
            component: resolve => require(
                ['@/pages/reportProblemReturnCar/damageReport'],
                resolve),
            meta: {
                title: '车辆损伤问题上报',
            },
            urlParams: []
        },
        {
            path: '/otherReturnCar',
            component: resolve => require(
                ['@/pages/reportProblemReturnCar/otherReport'],
                resolve),
            meta: {
                title: '车辆故障问题上报',
            },
            urlParams: []
        },
        {
            path: '/AgreementsAndRules',
            meta: {
                title: '平台协议规则及企业资质',
            },
            component: resolve => require(
                ['@/pages/AgreementsAndRules/AgreementsAndRules'],
                resolve
            )
        },
        {
            path: '/toRv2Go', // 大通房车对接免押金页面
            meta: {
                title: 'GoFun出行',
            },
            component: resolve => require(
                ['@/pages/toRv2Go/toRv2Go'],
                resolve
            )
        },
        {
            path: '/wholeRent/distribution-rule', // 整租分销规则说明
            component: resolve => require(
                ['@/pages/wholeRent/distribution-rule'],
                resolve),
            meta: {
                title: '规则说明',
            },
            urlParams: []
        },
        {
            path: '/rentIndex',  // 整租分销首页
            meta: {
                title: 'GoFun出行',
            },
            component: resolve => require(
                ['@/pages/rentIndex/rentIndex'],
                resolve)
        },
        {
            path: '/watsons',  // 520屈臣氏
            meta: {
                title: 'Gofun·屈臣氏520活动',
            },
            component: resolve => require(
                ['@/pages/watsons/index'],
                resolve)
        },
        {
            path: '/watsons/userInfo',  // 520屈臣氏留资
            meta: {
                title: '填写收货信息',
            },
            component: resolve => require(
                ['@/pages/watsons/userInfo'],
                resolve)
        },
        {
            path: '/wholeRent/orderConfirm',  // 整租预约单确认
            meta: {
                title: '整租预约规则确认',
            },
            component: resolve => require(
                ['@/pages/wholeRent/orderConfirm'],
                resolve)
        },
        {
            path: '/distributionToApp',  // 整租分销左侧菜单点击判断是否认证是否签章的中间页
            meta: {
                title: 'GoFun出行',
            },
            component: resolve => require(
                ['@/pages/wholeRent/distributionToApp'],
                resolve)
        },
        {
            path: '/wholeRent/distribution-coupon',  // 整租分销获取优惠券(领优惠券)
            meta: {
                title: '优惠来袭',
            },
            component: resolve => require(
                ['@/pages/wholeRent/distribution-coupon-new'],
                resolve)
        },
        {
            path: '/wholeRent/distributionCoupon',  // 整租分销获取优惠券(领优惠券),6月20日被举报了，部分人打不开，新换了地址
            meta: {
                title: '优惠来袭',
            },
            component: resolve => require(
                ['@/pages/wholeRent/distribution-coupon-new'],
                resolve)
        },

        {
            path: '/wholeRent/login',  // 整租分销登录页
            meta: {
                title: '登录',
            },
            component: resolve => require(
                ['@/pages/wholeRent/login'],
                resolve)
        },
        {
            path: '/rentRules', // 日租，整租规则说明
            component: resolve => require(
                // ['@/pages/rentIndex/rentRules'],
                ['@/pages/wholeRent/distribution-rule'],
                resolve),
            meta: {
                title: '规则说明',
            },
            urlParams: []
        },
        {
            path: '/distributionHome', // 分销C端首页
            component: resolve => require(
                ['@/pages/distribution/distributionHome'],
                resolve),
            meta: {
                title: '拍拍好友 稳赚两百',
            },
            urlParams: []
        },
        // 首约&智行联名活动,整租分销获取优惠券(领优惠券)
        {
            path: '/wholeRent/distributionCoupon-shouqiGofun',
            meta: {
                title: '优惠来袭',
            },
            component: resolve => require(
                ['@/pages/wholeRent/distribution-coupon-shouqiGofun'],
                resolve)
        },
        // 首约&智行联名活动,推荐有礼
        {
            path: '/shouqiGofunActivity',
            component: resolve => require(
                ['@/pages/distribution/shouqiGofunActiveity'],
                resolve),
            meta: {
                title: '推荐有礼',
            },
            urlParams: []
        },
        {
            path: '/distributionHomeActivity', // 市场活动0602
            component: resolve => require(
                ['@/pages/distribution/distributionHomeActivity'],
                resolve),
            meta: {
                title: '诚聘GoFun合伙人',
            },
            urlParams: []
        },
        {
            path: '/questionnaireUiForV6', // GoFun App 6.0 UI风格问卷调查
            component: resolve => require(
                ['@/pages/2020Activity/questionnaireForUI6.0/index'],
                resolve),
            meta: {
                title: '体验问卷',
            },
        },
        {
            path: '/gofunMa', // GoFun App ma
            component: resolve => require(
                ['@/pages/gofunMa/gofunMa.vue'],
                resolve),
            meta: {
                title: '预约试驾',
                keepAlive: true,
            },
        },
        {
            path: '/gofunMaAgent', // GoFun App ma
            component: resolve => require(
                ['@/pages/gofunMa/maAgent.vue'],
                resolve),
            meta: {
                title: '更换经销商',
            },
            urlParams: ['lon', 'lat', 'agentType']
        },
        {
            path: '/fullParkingFeeRules', // 整租停车费规则
            component: resolve => require(
                ['@/pages/fullParkingFeeRules/index'],
                resolve),
            meta: {
                title: '整租停车费规则',
            },
        },
        {
            path: '/fuelPrice', // 燃油费补交页面
            component: resolve => require(
                ['@/pages/fuelPrice/fuel'],
                resolve),
            meta: {
                title: '燃油费',
            },
        },
        {
            path: '/distributionHomeJump', // 整租停车费规则
            component: resolve => require(
                ['@/pages/distribution/jump'],
                resolve),
            meta: {
                title: '',
            },
        },
        {
            path: '/navCome',
            meta: {
                title: 'GoFun来袭',
                keepAlive: true,
            },
            component: resolve => require(
                ['@/pages/navCome/navCome'],
                resolve
            )
        },
        {
            path: '/agreement/paperInvoiceNotice', // 开发票不支持纸质发票提醒页面
            meta: {
                title: '重要提醒',
            },
            component: resolve => require(
                ['@/pages/Agreement/paperInvoiceNotice'],
                resolve
            )
        },
        {
            path: '/toXiaoJuFC', // 接通小桔房车
            meta: {
                title: 'GoFun出行',
            },
            component: resolve => require(
                ['@/pages/toXiaoJuFC/toXiaoJuFC'],
                resolve
            )
        },
        {
            path: '/agreement/huaBeiFenQi', // 花呗分期说明
            meta: {
                title: '花呗分期',
            },
            component: resolve => require(
                ['@/pages/Agreement/huaBeiFenQi'],
                resolve
            )
        },
        {
            path: '/bargainActivity', // 砍一刀裂变活动
            meta: {
                title: '砍价免费用车',
            },
            component: resolve => require(
                ['@/pages/bargainActivity/bargainHome'],
                resolve
            )
        },
        {
            path: '/bargainList', // 砍一刀裂变活动
            meta: {
                title: '砍价记录',
            },
            component: resolve => require(
                ['@/pages/bargainActivity/bargainList'],
                resolve
            )
        },
        {
            path: '/bargainMyself', // 砍一刀裂变活动
            meta: {
                title: '砍价免费用车',
            },
            component: resolve => require(
                ['@/pages/bargainActivity/bargainMyself'],
                resolve
            )
        },
        {
            path: '/bargainHelp', // 砍一刀裂变活动 帮砍页面
            meta: {
                title: '砍价免费用车',
            },
            component: resolve => require(
                ['@/pages/bargainActivity/bargainHelp'],
                resolve
            )
        },
        {
            path: '/bargainHelpDetail',
            meta: {
                title: '砍价免费用车',
            },
            component: resolve => require(
                ['@/pages/bargainActivity/bargainHelpDetail'],
                resolve
            )
        },
        {
            path: '/getLocationCity',
            meta: {
                title: '切换城市',
            },
            component: resolve => require(
                ['@/pages/bargainActivity/getLocationCity'],
                resolve
            )
        },
        {
            path: '/questionMain',
            meta: {
                title: '问卷调查',
            },
            component: resolve => require(
                ['@/pages/question/questionMain'],
                resolve
            )
        },
        {
            path: '/questionJixing',
            meta: {
                title: '问卷调查',
            },
            component: resolve => require(
                ['@/pages/question/questionJixing'],
                resolve
            )
        },{
            path: '/questionTDP',
            meta: {
                title: '问卷调查',
            },
            component: resolve => require(
                ['@/pages/question/questionTDP'],
                resolve
            )
        },
        {
            path: '/questionMainGET',
            meta: {
                title: '问卷调查',//GET
            },
            component: resolve => require(
                ['@/pages/question/questionMainGET'],
                resolve
            )
        },
        {
            path: '/questionActivity',
            meta: {
                title: '活动',
            },
            component: resolve => require(
                ['@/pages/question/questionActivity'],
                resolve
            )
        },
        {
            path: '/couponRedemption',
            meta: {
                title: '优惠券兑换',
            },
            component: resolve => require(
                ['@/pages/couponRedemption/couponRedemption'],
                resolve
            )
        },
        {
            path: '/p2pTakePhoto',
            meta: {
                title: '车辆拍照',
            },
            component: resolve => require(
                ['@/pages/p2pRent/p2p-takePhoto'],
                resolve
            )
        },
        {
            path: '/p2pOrderDetails',
            meta: {
                title: '订单详情',
            },
            component: resolve => require(
                ['@/pages/p2pRent/p2p-orderDetails'],
                resolve
            )
        },
        {
            path: '/p2pCarList',
            meta: {
                title: '车辆列表',
            },
            component: resolve => require(
                ['@/pages/p2pRent/p2p-carList'],
                resolve
            )
        },{
            path: '/p2pBrandList',
            meta: {
                title: '选择品牌',
            },
            component: resolve => require(
                ['@/pages/p2pRent/p2p-brandList'],
                resolve
            )
        },
        {
            path: '/p2pRentIndex',
            meta: {
              title: '车主直租首页',
            },
            component: resolve => require(
              ['@/pages/p2pRent/p2p-index'],
              resolve
            )
        },
        {
            path: '/p2pCarDetail',
            meta: {
                title: '车辆详情',
            },
            component: resolve => require(
                ['@/pages/p2pRent/p2p-carDetail'],
                resolve
            )
        },
        {
            path: '/p2pNewUserGuaid',
            meta: {
              title: '新手引导',
            },
            component: resolve => require(
              ['@/pages/p2pRent/p2p-newUserGuaid'],
              resolve
            )
        },
        {
            path: '/ahri',  // 阿狸
            meta: {
                title: '嗨Fun元旦用车抽盲盒',
            },
            component: resolve => require(
                ['@/pages/ahri/index'],
                resolve)
        },
        {
            path: '/ahri/userInfo',  // 阿狸
            meta: {
                title: '填写收货信息',
            },
            component: resolve => require(
                ['@/pages/ahri/userInfo'],
                resolve)
        },
        {
            path: '/yearEndInventory2020',  // 2020年终盘点
            meta: {
                title: 'FUN宝儿~',
            },
            component: resolve => require(
                ['@/pages/2020yearEndInventory/yearEndInventory2020'],
                resolve)
        },
        {
            path: '/advertising-detail',  // 广告详情
            meta: {
                title: '广告详情',
            },
            component: resolve => require(
                ['@/pages/advertising/detail'],
                resolve)
        },
        {
            path: '/festivalBook',  // 特惠租车，牛霸新年
            meta: {
                title: '特惠租车 牛霸新年',
            },
            component: resolve => require(
                ['@/pages/festivalBook/index'],
                resolve)
        },
        {
            path: '/newPeople-coupons',  // 新人专享券
            meta: {
                title: '新人专享券',
            },
            component: resolve => require(
                ['@/pages/newPeopleCoupons/index'],
                resolve)
        },
        {
            path: '/festivalBook-3',  // 特惠租车，牛霸新年三期
            meta: {
                title: '特惠租车 牛霸新年',
            },
            component: resolve => require(
                ['@/pages/festivalBook/index3'],
                resolve)
        },
        {
            path: '/GTETestDriveLanding',
            name: '',
            meta: {
                title: 'GoFun出行'
            },
            component: resolve => require(['@/pages/tasteDrive/GTETestDriveLanding'], resolve)
        },
        {
            path: '/GTETestDriveLanding2',
            name: '',
            meta: {
                title: 'GoFun出行'
            },
            component: resolve => require(['@/pages/tasteDrive/GTETestDriveLanding2'], resolve)
        },
        {
            path: '/GTETestDriveLandingForSZ', // 极星试驾首租活动开屏页
            name: '',
            meta: {
                title: 'GoFun出行'
            },
            component: resolve => require(['@/pages/tasteDrive/GTETestDriveLandingForSZ'], resolve)
        },
        //融创文旅活动start
        {
            path: '/guide', // 活动入口页
            name: 'guide',
            meta: {
                title: '融创文旅城'
            },
            component: resolve => require(['@/pages/sunacctg/guide'], resolve)
        },
        {
            path: '/weal', // 福利领取页
            name: 'weal',
            meta: {
                title: '领取福利'
            },
            component: resolve => require(['@/pages/sunacctg/weal'], resolve)
        },
        {
            path: '/wealAgain', // 福利领取页
            name: 'wealAgain',
            meta: {
                title: '领取福利'
            },
            component: resolve => require(['@/pages/sunacctg/wealAgain'], resolve)
        },
        {
            path: '/sunacctgMid', // 福利领取页
            name: 'sunacctgMid',
            meta: {
                title: '领取福利'
            },
            component: resolve => require(['@/pages/sunacctg/sunacctgMid'], resolve)
        },
        //融创文旅活动end
        {
            path: '/VolkswagenAG-employeesGoOuting', // 福利领取页
            name: 'VolkswagenAG-employeesGoOuting',
            meta: {
                title: '大众员工出行福利'
            },
            component: resolve => require(['@/pages/volk/index'], resolve)
        },
        //大众polo百人拼团
        {
            path:'/vwPoloXa',
            name:'VwPoloXA',
            meta:{
                title: '大众POLO百人拼团-西安'
            },
            component: resolve => require(['@/pages/vwPolo/XiAn'], resolve)
        },
        {
            path:'/vwPoloWh',
            name:'VwPoloWH',
            meta:{
                title: '大众POLO百人拼团-武汉'
            },
            component: resolve => require(['@/pages/vwPolo/WuHan'], resolve)
        },
        {
            path:'/vwPoloCq',
            name:'VwPoloCQ',
            meta:{
                title: '大众POLO百人拼团-重庆'
            },
            component: resolve => require(['@/pages/vwPolo/ChongQing'], resolve)
        },
        // 轩逸GO幸福项目 广告资源补偿
        {
            path:'/xuanyi_go',
            name:'xuanyi_go',
            meta:{
                title: '轩逸GO幸福'
            },
            component: resolve => require(['@/pages/xuanyi_go/index.vue'], resolve)
        },
        // 轮播图H5落地页
        {
            path:'/slider_LandingPage/:id',
            name:'slider_LandingPage',
            meta:{
                title: '活动详情'
            },
            component: resolve => require(['@/pages/slider_LandingPage/index.vue'], resolve)
        },
        // 轮播图H5落地页 规则
        {
            path:'/slider_LandingPage_rules',
            name:'slider_LandingPage_rules',
            meta:{
                title: '活动规则'
            },
            component: resolve => require(['@/pages/slider_LandingPage/rules.vue'], resolve),
            beforeEnter(to,form,next){

                if(to.query.id === '76a410e7dec444d6bb73d736ad18f92c') document.title = '产品说明'
                next()
            }
        },
        // 留咨页面
        {
            path:'/preserveInformation_coupons',
            name:'preserveInformation_coupons',
            meta:{
                title: '留资领券'
            },
            component: resolve => require(['@/pages/preserveInformation/preserveInformation_coupons.vue'], resolve)
        },
        {
            path:'/download_app',
            name:'download_app',
            meta:{
                title: '下载页'
            },
            component: resolve => require(['@/pages/download_app/index.vue'], resolve)
        },
        {
            path:'/download_crowdsource',
            name:'download_crowdsource',
            meta:{
                title: '下载页'
            },
            component: resolve => require(['@/pages/download_app/download_crowdsource.vue'], resolve)
        },
        {
            path:'/download_business',
            name:'download_business',
            meta:{
                title: '下载页'
            },
            component: resolve => require(['@/pages/download_app/download_business.vue'], resolve)
        },
        {
            path:'/sign_canvas',
            name:'sign_canvas',
            meta:{
                title: '请输入签名'
            },
            component: resolve => require(['@/pages/wholerentV2/index.vue'], resolve)
        },
        {
            path:'/view',
            name:'view',
            meta:{
                title: 'GoFun出行'
            },
            component: resolve => require(['@/pages/wholerentV2/view.vue'], resolve)
        },
        {
            path:'/vote',
            name:'vote',
            meta:{
                title: '整租投票'
            },
            component: resolve => require(['@/pages/vote'], resolve)
        },
        // {
        //     path:'/gofunSelect',
        //     name:'gofunSelect',
        //     meta:{
        //         title: 'GoFun优选'
        //     },
        //     component: resolve => require(['@/pages/gofunSelect/index.vue'], resolve)
        // },
        {
            path:'/buyHistory',
            name:'buyHistory',
            meta:{
                title: '购买记录'
            },
            component: resolve => require(['@/pages/gofunSelect/buyHistory.vue'], resolve)
        },
        {
            path:'/drivingTest',
            name:'drivingTest',
            meta:{
                title: '试乘试驾'
            },
            component: resolve => require(['@/pages/gofunSelect/drivingTest.vue'], resolve)
        },
        // gofun优选重构
        {
            path:'/gofunSelect',
            name:'gofunSelect',
            meta: {
                keepAlive: true,
                title: 'GoFun优选'
            },
            component: resolve => require(['@/pages/gofunSelectNew/index.vue'], resolve)
        },
        {
            path:'/contentDetail',
            name:'contentDetail',
            meta:{
                title: 'GoFun优选'
            },
            component: resolve => require(['@/pages/gofunSelectNew/details.vue'], resolve)
        },
        {
            path:'/shopList',
            name:'shopList',
            meta:{
                title: 'GoFun优选'
            },
            component: resolve => require(['@/pages/gofunSelectNew/shopList.vue'], resolve)
        },
        {
            path:'/eCard',
            name:'eCard',
            meta:{
                title: '鸿途e卡'
            },
            component: resolve => require(['@/pages/eCard/index.vue'], resolve),
        },
        {
            path: '/eCard/recharge',
            name: 'eCardRecharge',
            meta: {
                title: '购买'
            },
            component: resolve => require(['@/pages/eCard/recharge.vue'], resolve),
        },
        {
            path: '/eCard/result',
            name: 'eCardRecharge',
            meta: {
                title: '购买结果'
            },
            component: resolve => require(['@/pages/eCard/result.vue'], resolve),
        },
        {
            path: '/eCard/transactions',
            name: 'eCardRecharge',
            meta: {
                title: '权益记录'
            },
            component: resolve => require(['@/pages/eCard/transactions.vue'], resolve),
        },
        {
            path: '/eCard/detail',
            name: 'eCardDetail',
            meta: {
                title: '权益记录详情'
            },
            component: resolve => require(['@/pages/eCard/detail.vue'], resolve),
        },
        {
            path: '/eCard/rule',
            name: 'eCardrule',
            meta: {
                title: '规则说明'
            },
            component: resolve => require(['@/pages/eCard/rule.vue'], resolve),
        },
        //小鹏试驾留资
        {
            path:'/xiaopengTestDrive',
            name:'xiaopengTestDrive',
            meta:{
                title: '小鹏试驾'
            },
            component: resolve => require(['@/pages/xiaopengTestDrive/index.vue'], resolve)
        },
        //舟山留资
        {
            path:'/preserveInformation-zhoushan',
            name:'preserveInformation-zhoushan',
            meta:{
                title: '舟山新车售卖留咨'
            },
            component: resolve => require(['@/pages/preserveInformation/zhoushan/index.vue'], resolve)
        },
        {
            path: '/long-rent/rentForm',  // 整租新留资
            name:'rentForm',
            meta: {
                title: '企业用车留资',
            },
            component: resolve => require(
                ['@/pages/longRent/newSubmitIntentionCar'], resolve)
        },
        // {
        //     path: '/lucky',
        //     meta: {
        //         title: 'lucky',
        //     },
        //     component: resolve => require(
        //         ['@/pages/lucky'], resolve)
        // },
        // {
        //     path: '/divination',
        //     meta: {
        //         title: 'divination',
        //     },
        //     component: resolve => require(
        //         ['@/pages/divination'], resolve)
        // },
        {
            path: '/combinParkingInfo',  // app6.0聚合网点详情
            component: resolve => require(
                ['@/pages/combinParkingInfo/index.vue'],
                resolve),
            meta: {
                title: '网点详情',
            },
        },
        {
            path: '/2021yearEndInventory',  // 2021年度账单
            component: resolve => require(
                ['@/pages/2021yearEndInventory/index.vue'],
                resolve),
            meta: {
                title: '2021年度账单',
            },
        },
        {
            path: '/2022yearEndInventory',  // 2022年度账单
            component: resolve => require(
                ['@/pages/2022yearEndInventory/index.vue'],
                resolve),
            meta: {
                title: '2022年度账单',
            },
        },
        {
            path: '/2023yearEndInventory',  // 2022年度账单
            component: resolve => require(
                ['@/pages/2023yearEndInventory/index.vue'],
                resolve),
            meta: {
                title: '2023年度账单',
            },
        },
        {
            path: '/mall',
            name: 'mall',
            component: resolve => require(['@/pages/mall/presell/index.vue'], resolve),
            meta: {title: '预售商品列表'},
        },
        {
            path: '/mall/goodsInfo',
            name: 'goodsInfo',
            component: resolve => require(['@/pages/mall/presell/goodsInfo.vue'], resolve),
            meta: {title: '商品详情'},
        },
        {
            path: '/mall/orderLogs',
            name: 'orderLogs',
            component: resolve => require(['@/pages/mall/presell/orderLogs.vue'], resolve),
            meta: {title: '预售购买记录'},
        },
        {
            path: '/mall/agreement',
            name: 'agreement',
            component: resolve => require(['@/pages/mall/presell/agreement.vue'], resolve),
            meta: {title: '预售协议'},
        },
        {
            path: '/mall/orderInfo',
            name: 'orderInfo',
            component: resolve => require(['@/pages/mall/presell/orderInfo.vue'], resolve),
            meta: {title: '订单详情'},
        },
        ...mallRouter,
        {
            path: '/pay/cashier',
            name: 'cashier',
            component: resolve => require(['@/commonPages/Cashier/Pay'], resolve),
            meta: {title: '收银台'},
        },
        {
            path: '/agreement/appNoPWDPayRule',
            name: 'appNoPWDPayRule',
            component: resolve => require(['@/pages/Agreement/appNoPWDPay-rule'], resolve),
            meta: {title: '免密支付规则'},
        },
        {
            path: '/login',  // 登录
            meta: {
                title: '登录',
            },
            component: resolve => require(['@/pages/login/index'],resolve)
        },
        {
            path: '/longWholeRent',  //整租首页
            meta: {
                title: '长租车型',
            },
            component: resolve => require(['@/pages/longWholeRent/index'], resolve),
        },
        {
            path: '/longWholeRentV2',  //长租页面第二版
            meta: {
                title: '选择车型',
            },
            component: resolve => require(['@/pages/longWholeRent/v2'], resolve),
        },
        {
            path: '/deposit_rule',  //长租页面第二版
            meta: {
                title: '保证金规则说明',
            },
            component: resolve => require(['@/pages/deposit_rule/index'], resolve),
        },
        {
            path: '/orderCarPhoto',  //长租页面第二版
            meta: {
                title: '验车照片',
            },
            component: resolve => require(['@/pages/orderCarPhoto/OrderCarPhoto'], resolve),
        },
        {
            path: '/distribution',  //分销首页-我的分销
            meta: {
                title: '我的分销',
            },
            component: resolve => require(['@/pages/distributionV2/index'], resolve),
        },
        {
            path: '/distribution/detail',  //分销首页-我的分销-详情
            meta: {
                title: '活动',
            },
            component: resolve => require(['@/pages/distributionV2/detail'], resolve),
        },
        {
            path: '/distribution/withdrawal',  //提现
            meta: {
                title: '提现',
            },
            component: resolve => require(['@/pages/distributionV2/withdrawal'], resolve),
        },
        {
            path: '/distribution/income',  //个人收益
            meta: {
                title: '个人收益',
            },
            component: resolve => require(['@/pages/distributionV2/income'], resolve),
        },
        ...saleCarRouter,
        {
            // app/小程序中的 学生认证
            path: '/student-verify',
            meta: {
                title: '学生认证',
            },
            component: resolve => require(['@/pages/student-verify/index.vue'], resolve),
        },
        {
            // 如何获取验证码的说明页面
            path: '/getCAPTCHA',
            meta: {
                title: '学生认证',
            },
            component: resolve => require(['@/pages/student-verify/getCAPTCHA.vue'], resolve),
        }
    ],
})



// WEBPACK FOOTER //
// src/router/index.js